import { render, staticRenderFns } from "./BorderBox.vue?vue&type=template&id=6faf5e97"
import script from "./BorderBox.vue?vue&type=script&lang=js"
export * from "./BorderBox.vue?vue&type=script&lang=js"
import style0 from "./BorderBox.vue?vue&type=style&index=0&id=6faf5e97&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports